import { Button, Table, TableBody, TableCell, TableHead, TableRow } from '@aws-amplify/ui-react';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

import { WorkEntriesPerMonth } from './work-entries-per-month.component';
import { pad } from '../util/date-helpers';
import { LoadedMonth } from './load-entries';

import 'react-datepicker/dist/react-datepicker.css';

export interface WorkEntriesProps {
    loadedMonths: LoadedMonth[];
}

export const WorkEntries: React.FC<WorkEntriesProps> = ({ loadedMonths }) => {
    const [selectedEntry, setSelectedEntry] = useState<[number, number]>();
    const [selectedDate, setSelectedDate] = useState<Date | null>();

    if (selectedEntry != null) {
        return <WorkEntriesPerMonth month={selectedEntry[1]} year={selectedEntry[0]} onClose={() => setSelectedEntry(undefined)} />;
    }

    return (
        <Table caption="" highlightOnHover>
            <TableHead>
                <TableRow>
                    <TableCell as="th">Date</TableCell>
                    <TableCell as="th">Worked</TableCell>
                    <TableCell as="th">Result</TableCell>
                    <TableCell as="th">Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {loadedMonths.map((entry) => (
                    <TableRow key={entry.year + '-' + entry.month}>
                        <TableCell>
                            {pad(entry.month)}.{entry.year}
                        </TableCell>
                        <TableCell>
                            {entry.workHours} / {entry.requiredHours}
                        </TableCell>
                        <TableCell style={{ color: entry.workHours >= entry.requiredHours ? 'green' : 'red' }}>
                            {entry.workHours - entry.requiredHours}
                        </TableCell>
                        <TableCell>
                            <Button size="small" onClick={() => setSelectedEntry([entry.year, entry.month])}>
                                💢
                            </Button>
                        </TableCell>
                    </TableRow>
                ))}
                <TableRow>
                    <TableCell>
                        <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} dateFormat="MM.yyyy" showMonthYearPicker />
                    </TableCell>
                    <TableCell>-</TableCell>
                    <TableCell>-</TableCell>
                    <TableCell>
                        {selectedDate != null && (
                            <Button size="small" onClick={() => setSelectedEntry([selectedDate.getFullYear(), selectedDate.getMonth() + 1])}>
                                💢
                            </Button>
                        )}
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};
